import styled from 'styled-components';

export const ListPageContainer = styled.div`
  padding: 60px 36px 25px;
`;
